import React, { useState, useEffect } from 'react';
import Swiper from 'swiper';

// Assets
import '../../assets/css/swiper.min.css';
import './CardSider.scss';

const CardSlider = ({ children }) => {
  const [sliderInit, setSliderInit] = useState(false);
  const toggleSliderInit = () => setSliderInit(!sliderInit);

  // TODO: add pause the slider
  const [mousePause, setMousePause] = useState(false);
  const toggleMousePause = () => setMousePause(!mousePause);

  useEffect(() => {
    if (!sliderInit) {
      initSwiper();
      toggleSliderInit();
    }
  }, [sliderInit]);

  useEffect(() => {
    const sliderContainer = document.getElementById('widget-slider');
    if (sliderInit) {
      if (mousePause) {
        sliderContainer.swiper.autoplay.stop();
      } else {
        sliderContainer.swiper.autoplay.start();
      }
    }
  }, [mousePause]);

  const initSwiper = () => {
    const mainBanner = document.getElementById('widget-slider');
    if (mainBanner && mainBanner.swiper) {
      mainBanner.swiper.destroy(false, false);
    }
    const autoplayTime = 5000;
    const swiper = new Swiper(mainBanner, {
      slidesPerView: 1,
      spaceBetween: 15,
      slidesPerGroup: 1,
      autoHeight: false,
      centeredSlides: false,
      speed: 800,
      loop: true,
      // init: false,
      autoplay: {
        delay: autoplayTime,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        430: {
          slidesPerGroup: 1,
          slidesPerView: 1,
          spaceBetween: 30,
        },
        768: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  };

  const control = (
    <>
      <div className="swiper-pagination" />
      <div className="swiper-button-next" />
      <div className="swiper-button-prev" />
      <div
        role="button"
        tabIndex="0"
        className={
          mousePause
            ? 'widget-slider-container__slider-pause is-active'
            : 'widget-slider-container__slider-pause'
        }
        onClick={() => toggleMousePause()}
        onKeyPress={() => toggleMousePause()}
      >
        <div className="pause-button" />
      </div>
    </>
  );

  return (
    <>
      <div className="swiper-container" id="widget-slider">
        <div className="swiper-wrapper">{children}</div>
      </div>
      {control}
    </>
  );
};

export default CardSlider;
